export default "__VITE_ASSET__Dvmp_Uzt__"